/* loaded by smart-asset */
export default require("./left-arrow~EgzQkufV.svg")